import { render } from "./SplashMini.vue?vue&type=template&id=f436e6bc&scoped=true&lang=html"
import script from "./SplashMini.vue?vue&type=script&lang=js"
export * from "./SplashMini.vue?vue&type=script&lang=js"

import "./SplashMini.vue?vue&type=style&index=0&id=f436e6bc&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f436e6bc"]])

export default __exports__